import {Component, input, computed} from '@angular/core';
import {StatutsTrajet, StatutTrajetEnum} from '../../../gestion-navette/onglets-gestion-navette/trajets/model/statut-trajet.enum'

@Component({
	selector: 'app-label-statut-trajet',
	templateUrl: './label-statut-trajet.component.html',
	styleUrl: './label-statut-trajet.component.scss'
})
export class LabelStatutTrajetComponent {
	// Inputs
	statut = input.required<StatutTrajetEnum>();

	/**
	 * Clé de traduction du statut du trajet.
	 */
	cleTraductionStatut = computed(() => StatutsTrajet.get(this.statut()).cleTraduction);

	/**
	 * Couleur associée au statut du trajet.
	 */
	couleurStatut = computed(() => StatutsTrajet.get(this.statut()).couleur);

	constructor() {
	}
}
